import script from "./goRinSyo0051.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0051.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0051.vue?vue&type=style&index=0&id=6c161140&lang=scss"

const __exports__ = script;

export default __exports__